import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import setupLogRocketReact from 'logrocket-react';

import { theme } from '@/styles/theme';
import { queryClient } from '@/utils/queryClient';
import { AppRouter } from '@/components/Router';
import { ErrorBoundary } from '@/components/Common/ErrorBoundary';
import { CustomAuth0Provider } from './providers/Auth0Provider';
import LogRocket, { debugCSSCapture } from '@/utils/logrocket';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@/styles/global.css';

if (import.meta.env.PROD && import.meta.env.VITE_LOGROCKET_APP_ID) {
  setupLogRocketReact(LogRocket);
}

function App(): React.ReactElement {
  useEffect(() => {
    if (import.meta.env.PROD && import.meta.env.VITE_LOGROCKET_APP_ID) {
      setTimeout(() => {
        debugCSSCapture();
      }, 1000);
    }
  }, []);

  return (
    <BrowserRouter>
      <CustomAuth0Provider>
        <QueryClientProvider client={queryClient}>
          <MantineProvider theme={theme}>
            <ErrorBoundary>
              <Notifications position="top-right" />
              <AppRouter />
              <ReactQueryDevtools initialIsOpen={false} />
            </ErrorBoundary>
          </MantineProvider>
        </QueryClientProvider>
      </CustomAuth0Provider>
    </BrowserRouter>
  );
}

export default App;
